import { dataFetch } from '@lib/ggj-utils'

export default {
    // POST 内容发布前的校验  add
    verifyFeed(params) {
        return dataFetch('/service/pgc.issueVerify', params, { headers: { 'gj-ua': 4 }})
    },
    // GET 添加商品搜索  add
    async searchGoods(params) {
        return dataFetch('/wholesale/api/brand/brandProductList', params, { method: 'get' ,headers:{'gj-ua':4}})
    },
    // 获取话题列表
    getHotTopicList(params) {
        return dataFetch('/service/pgc.getSheroHotTopicList', params)
    },
    // 获取话题下绑定的商品（新增功能）
    fetchTopicGoods(params){
        return dataFetch('/service/pgc.getTopicItemList', params, { method: 'get', headers: { 'gj-ua': 4 } })
    }
}
